export const notes = {
  title: 'Notes',
  subtitle: 'Sticky Notes',
  
  // Actions
  actions: {
    createNote: 'New Note',
    editNote: 'Edit',
    deleteNote: 'Delete',
    saveNote: 'Save',
    cancelEdit: 'Cancel',
    archiveNote: 'Archive',
    restoreNote: 'Restore',
    changeColor: 'Change Color',
    moveNote: 'Move'
  },

  // Status
  status: {
    empty: 'Empty note...',
    loading: 'Loading notes...',
    noNotes: 'You have no notes yet',
    noResults: 'No results',
    archived: 'Archived',
    created: 'Note created',
    updated: 'Note updated',
    deleted: 'Note deleted'
  },

  // Search and filter
  search: {
    placeholder: 'Search notes...',
    noResults: 'No notes found',
    resultsCount: '{count} notes found'
  },

  // Colors
  colors: {
    yellow: 'Yellow',
    blue: 'Blue',
    green: 'Green',
    pink: 'Pink',
    purple: 'Purple',
    orange: 'Orange'
  },

  // Priorities
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  },

  // Tips and help
  tips: {
    title: 'Tips:',
    drag: 'Drag notes to move them',
    edit: 'Click the pencil icon to edit',
    menu: 'Use the three-dot menu to change colors',
    create: 'Click "New Note" to create your first note!'
  },

  // Error messages
  errors: {
    loadFailed: 'Failed to load notes',
    createFailed: 'Failed to create note',
    updateFailed: 'Failed to update note',
    deleteFailed: 'Failed to delete note',
    archiveFailed: 'Failed to archive note'
  },

  // Menus
  menu: {
    archive: 'Archive',
    viewArchived: 'View archived notes',
    backToNotes: 'Back to notes'
  },

  // Tags
  tags: {
    add: 'Add tag',
    remove: 'Remove tag',
    placeholder: 'Tag name...',
    all: 'All tags',
    none: 'No tags'
  },

  // Grouping
  grouping: {
    none: 'No grouping',
    byTag: 'By tag',
    byColor: 'By color',
    byDate: 'By date'
  },

  // Placeholders
  placeholders: {
    noteContent: 'Write something...',
    searchNotes: 'Search notes...',
    clickToEdit: 'Click here to edit...'
  }
};
